"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockSalesOrders = exports.mockSerializedSalesOrders = void 0;
const moment = require("moment-timezone");
const SalesOrder_1 = require("../../../models/SalesOrder");
const mockRetailLocations_1 = require("./mockRetailLocations");
const mockRetailCustomers_1 = require("./mockRetailCustomers");
const mockSalesOrderItems_1 = require("./mockSalesOrderItems");
const TSalesOrderType_1 = require("../../../types/TSalesOrderType");
const currentUnixTimestamp_1 = require("../../../../../../apis/spg/util/currentUnixTimestamp");
const guid_1 = require("../../../../../../apis/spg/util/guid");
const printing_1 = require("../../../types/printing");
const IPromotion_1 = require("../../../types/IPromotion");
const mockSalesOrderRefunds_1 = require("./mockSalesOrderRefunds");
exports.mockSerializedSalesOrders = [
    {
        // outstanding delivery
        salesOrderId: (0, guid_1.createGuid)(),
        retailLocation: mockRetailLocations_1.mockSerializedRetailLocations[0],
        retailCustomer: mockRetailCustomers_1.mockSerializedRetailCustomers[0],
        salesOrderItems: mockSalesOrderItems_1.mockSerializedSalesOrderItems,
        type: TSalesOrderType_1.TSalesOrderType.Delivery,
        deliveryAddress: {
            fullAddress: "123 Awesome St Sydney NSW 2000",
            streetAddress: "123 Awesome St",
            suburb: "Sydney",
            state: "NSW",
            country: "Australia",
            postcode: "2000",
            lat: -31.9422222,
            lng: 115.9241667
        },
        notes: "some delivery instructions",
        paymentToken: "some-payment-token",
        createdAt: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        updatedAt: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        placementTime: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        requestedReadyTime: moment()
            .add(10, "m")
            .unix(),
        predictedCompletionTime: moment()
            .add(10, "m")
            .unix(),
        promotions: [
            {
                description: "10% off all standard drinks",
                priceDiscounted: 1.2,
                type: IPromotion_1.TPromotionType.Item
            }
        ],
        totalPrice: 22.3,
        externalDeliveryReference: "86313",
        deliveryDriver: {
            name: "John D.",
            phoneNumber: "+15555555555",
            pickupTime: "2018-08-22T17:20:28Z",
            dropoffTime: "2018-08-22T17:20:45Z",
            vehicle: {
                brand: "Toyota",
                model: "Corolla",
                year: "2006"
            },
            location: {
                lat: -31.9422222,
                lng: 115.9241667
            }
        },
        salesOrderRefund: mockSalesOrderRefunds_1.mockSerializedSalesOrderRefunds[0]
    },
    {
        // outstanding pickup
        salesOrderId: (0, guid_1.createGuid)(),
        retailLocation: mockRetailLocations_1.mockSerializedRetailLocations[0],
        retailCustomer: mockRetailCustomers_1.mockSerializedRetailCustomers[0],
        salesOrderItems: mockSalesOrderItems_1.mockSerializedSalesOrderItems,
        type: TSalesOrderType_1.TSalesOrderType.Pickup,
        deliveryAddress: {
            fullAddress: "123 Awesome St Sydney NSW 2000",
            streetAddress: "123 Awesome St",
            suburb: "Sydney",
            state: "NSW",
            country: "Australia",
            postcode: "2000",
            lat: -31.9422222,
            lng: 115.9241667
        },
        notes: "some delivery instructions",
        paymentToken: "some-payment-token",
        createdAt: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        updatedAt: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        placementTime: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        requestedReadyTime: moment()
            .add(10, "m")
            .unix(),
        predictedCompletionTime: moment()
            .add(10, "m")
            .unix(),
        promotions: [
            {
                description: "10% off all standard drinks",
                priceDiscounted: 1.2,
                type: IPromotion_1.TPromotionType.Item
            }
        ],
        totalPrice: 22.3,
        externalDeliveryReference: "86313",
        deliveryDriver: {
            name: "John D.",
            phoneNumber: "+15555555555",
            pickupTime: "2018-08-22T17:20:28Z",
            dropoffTime: "2018-08-22T17:20:45Z",
            vehicle: {
                brand: "Toyota",
                model: "Corolla",
                year: "2006"
            },
            location: {
                lat: -31.9422222,
                lng: 115.9241667
            }
        }
    },
    {
        // completed delivery
        salesOrderId: (0, guid_1.createGuid)(),
        retailLocation: mockRetailLocations_1.mockSerializedRetailLocations[0],
        retailCustomer: mockRetailCustomers_1.mockSerializedRetailCustomers[0],
        salesOrderItems: mockSalesOrderItems_1.mockSerializedSalesOrderItems,
        type: TSalesOrderType_1.TSalesOrderType.Delivery,
        deliveryAddress: {
            fullAddress: "123 Awesome St Sydney NSW 2000",
            streetAddress: "123 Awesome St",
            suburb: "Sydney",
            state: "NSW",
            country: "Australia",
            postcode: "2000",
            lat: -31.9422222,
            lng: 115.9241667
        },
        notes: "some delivery instructions",
        paymentToken: "some-payment-token",
        createdAt: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        updatedAt: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        placementTime: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        requestedReadyTime: moment()
            .add(10, "m")
            .unix(),
        predictedCompletionTime: moment()
            .add(10, "m")
            .unix(),
        startedAssemblyAt: moment()
            .add(15, "m")
            .unix(),
        assembledAt: moment()
            .add(20, "m")
            .unix(),
        pickedUpByDeliveryDriverAt: moment()
            .add(25, "m")
            .unix(),
        completedAt: moment()
            .add(40, "m")
            .unix(),
        promotions: [
            {
                description: "10% off all standard drinks",
                priceDiscounted: 1.2,
                type: IPromotion_1.TPromotionType.Item
            }
        ],
        totalPrice: 22.3,
        externalDeliveryReference: "86313",
        deliveryDriver: {
            name: "John D.",
            phoneNumber: "+15555555555",
            pickupTime: "2018-08-22T17:20:28Z",
            dropoffTime: "2018-08-22T17:20:45Z",
            vehicle: {
                brand: "Toyota",
                model: "Corolla",
                year: "2006"
            },
            location: {
                lat: -31.9422222,
                lng: 115.9241667
            }
        }
    },
    {
        // refunded delivery
        salesOrderId: (0, guid_1.createGuid)(),
        retailLocation: mockRetailLocations_1.mockSerializedRetailLocations[0],
        retailCustomer: mockRetailCustomers_1.mockSerializedRetailCustomers[0],
        salesOrderItems: mockSalesOrderItems_1.mockSerializedSalesOrderItems,
        type: TSalesOrderType_1.TSalesOrderType.Delivery,
        deliveryAddress: {
            fullAddress: "123 Awesome St Sydney NSW 2000",
            streetAddress: "123 Awesome St",
            suburb: "Sydney",
            state: "NSW",
            country: "Australia",
            postcode: "2000",
            lat: -31.9422222,
            lng: 115.9241667
        },
        notes: "some delivery instructions",
        paymentToken: "some-payment-token",
        createdAt: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        updatedAt: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        placementTime: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        requestedReadyTime: moment()
            .add(10, "m")
            .unix(),
        predictedCompletionTime: moment()
            .add(10, "m")
            .unix(),
        refundedAt: moment()
            .add(20, "m")
            .unix(),
        promotions: [
            {
                description: "10% off all standard drinks",
                priceDiscounted: 1.2,
                type: IPromotion_1.TPromotionType.Item
            }
        ],
        totalPrice: 22.3,
        externalDeliveryReference: "86313",
        deliveryDriver: {
            name: "John D.",
            phoneNumber: "+15555555555",
            pickupTime: "2018-08-22T17:20:28Z",
            dropoffTime: "2018-08-22T17:20:45Z",
            vehicle: {
                brand: "Toyota",
                model: "Corolla",
                year: "2006"
            },
            location: {
                lat: -31.9422222,
                lng: 115.9241667
            }
        }
    },
    {
        // printing delivery
        salesOrderId: (0, guid_1.createGuid)(),
        retailLocation: mockRetailLocations_1.mockSerializedRetailLocations[0],
        retailCustomer: mockRetailCustomers_1.mockSerializedRetailCustomers[0],
        salesOrderItems: mockSalesOrderItems_1.mockSerializedSalesOrderItems,
        type: TSalesOrderType_1.TSalesOrderType.Delivery,
        deliveryAddress: {
            fullAddress: "123 Awesome St Sydney NSW 2000",
            streetAddress: "123 Awesome St",
            suburb: "Sydney",
            state: "NSW",
            country: "Australia",
            postcode: "2000",
            lat: -31.9422222,
            lng: 115.9241667
        },
        notes: "some delivery instructions",
        paymentToken: "some-payment-token",
        createdAt: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        updatedAt: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        placementTime: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        requestedReadyTime: moment()
            .add(10, "m")
            .unix(),
        predictedCompletionTime: moment()
            .add(10, "m")
            .unix(),
        printInfo: {
            status: printing_1.TSalesOrdersOrderPrintStatus.Printing,
            completedAt: null,
            failureReason: null
        },
        promotions: [
            {
                description: "10% off all standard drinks",
                priceDiscounted: 1.2,
                type: IPromotion_1.TPromotionType.Item
            }
        ],
        totalPrice: 22.3,
        externalDeliveryReference: "86313",
        deliveryDriver: {
            name: "John D.",
            phoneNumber: "+15555555555",
            pickupTime: "2018-08-22T17:20:28Z",
            dropoffTime: "2018-08-22T17:20:45Z",
            vehicle: {
                brand: "Toyota",
                model: "Corolla",
                year: "2006"
            },
            location: {
                lat: -31.9422222,
                lng: 115.9241667
            }
        }
    },
    {
        // printed delivery
        salesOrderId: (0, guid_1.createGuid)(),
        retailLocation: mockRetailLocations_1.mockSerializedRetailLocations[0],
        retailCustomer: mockRetailCustomers_1.mockSerializedRetailCustomers[0],
        salesOrderItems: mockSalesOrderItems_1.mockSerializedSalesOrderItems,
        type: TSalesOrderType_1.TSalesOrderType.Delivery,
        deliveryAddress: {
            fullAddress: "123 Awesome St Sydney NSW 2000",
            streetAddress: "123 Awesome St",
            suburb: "Sydney",
            state: "NSW",
            country: "Australia",
            postcode: "2000",
            lat: -31.9422222,
            lng: 115.9241667
        },
        notes: "some delivery instructions",
        paymentToken: "some-payment-token",
        createdAt: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        updatedAt: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        placementTime: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        requestedReadyTime: moment()
            .add(10, "m")
            .unix(),
        predictedCompletionTime: moment()
            .add(10, "m")
            .unix(),
        printInfo: {
            status: printing_1.TSalesOrdersOrderPrintStatus.Completed,
            completedAt: moment()
                .add(2, "m")
                .unix(),
            failureReason: null
        },
        promotions: [
            {
                description: "10% off all standard drinks",
                priceDiscounted: 1.2,
                type: IPromotion_1.TPromotionType.Item
            }
        ],
        totalPrice: 22.3,
        externalDeliveryReference: "86313",
        deliveryDriver: {
            name: "John D.",
            phoneNumber: "+15555555555",
            pickupTime: "2018-08-22T17:20:28Z",
            dropoffTime: "2018-08-22T17:20:45Z",
            vehicle: {
                brand: "Toyota",
                model: "Corolla",
                year: "2006"
            },
            location: {
                lat: -31.9422222,
                lng: 115.9241667
            }
        }
    },
    {
        // printing failed delivery
        salesOrderId: (0, guid_1.createGuid)(),
        retailLocation: mockRetailLocations_1.mockSerializedRetailLocations[0],
        retailCustomer: mockRetailCustomers_1.mockSerializedRetailCustomers[0],
        salesOrderItems: mockSalesOrderItems_1.mockSerializedSalesOrderItems,
        type: TSalesOrderType_1.TSalesOrderType.Delivery,
        deliveryAddress: {
            fullAddress: "123 Awesome St Sydney NSW 2000",
            streetAddress: "123 Awesome St",
            suburb: "Sydney",
            state: "NSW",
            country: "Australia",
            postcode: "2000",
            lat: -31.9422222,
            lng: 115.9241667
        },
        notes: "some delivery instructions",
        paymentToken: "some-payment-token",
        createdAt: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        updatedAt: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        placementTime: (0, currentUnixTimestamp_1.currentUnixTimestamp)(),
        requestedReadyTime: moment()
            .add(10, "m")
            .unix(),
        predictedCompletionTime: moment()
            .add(10, "m")
            .unix(),
        printInfo: {
            status: printing_1.TSalesOrdersOrderPrintStatus.Failed,
            completedAt: null,
            failureReason: "Paper jam"
        },
        promotions: [
            {
                description: "10% off all standard drinks",
                priceDiscounted: 1.2,
                type: IPromotion_1.TPromotionType.Item
            }
        ],
        totalPrice: 22.3,
        externalDeliveryReference: "86313",
        deliveryDriver: {
            name: "John D.",
            phoneNumber: "+15555555555",
            pickupTime: "2018-08-22T17:20:28Z",
            dropoffTime: "2018-08-22T17:20:45Z",
            vehicle: {
                brand: "Toyota",
                model: "Corolla",
                year: "2006"
            },
            location: {
                lat: -31.9422222,
                lng: 115.9241667
            }
        }
    }
];
exports.mockSalesOrders = exports.mockSerializedSalesOrders.map((salesOrder) => {
    const salesOrderModel = SalesOrder_1.SalesOrder.unserialize(salesOrder);
    salesOrderModel.salesOrderItems = mockSalesOrderItems_1.mockSalesOrderItems;
    return salesOrderModel;
});
//# sourceMappingURL=mockSalesOrders.js.map